// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__cU0dC","newsletter":"Home_newsletter__GWTrK"};